export const moneyFormatter = (value) => {
  const formatter = new Intl.NumberFormat("ko-KR");

  if (!value) return "0원";

  return formatter.format(value) + "원";
};
